import React from 'react';
import cn from '@/utils/cn';
import noteDate from './noteDate';
import StatusPill from './StatusPill';
import type { SlideStatus } from './useSlideStatuses';

// Spans throughout: the list renders inside the row's dialog trigger, a button.
const NoteLine = ({ note }: { note: SlideStatus }) => (
  // A fixed pill column keeps the note text aligned from one note to the next.
  <span className="tw-grid tw-grid-cols-[4.25rem_1fr] tw-gap-x-2 tw-py-2 first:tw-pt-0 last:tw-pb-0">
    <span className="tw-inline-flex tw-h-5 tw-items-center">
      <StatusPill status={note.status} />
    </span>
    <span className="tw-flex tw-flex-col tw-gap-1 tw-text-left">
      <span
        className={cn('tw-leading-5', note.completed_at ? 'tw-text-spa-tertiary' : 'tw-text-spa-primary')}
      >
        {note.note ?? <span className="tw-italic tw-text-spa-tertiary">No note text</span>}
        {note.completed_at && (
          <i
            aria-label="Done"
            className="fa fa-check-circle tw-ml-1.5 tw-text-spa-success tw-leading-none"
            title="Done"
          />
        )}
      </span>
      <span className="tw-text-xs tw-text-spa-tertiary">
        {note.staffer_name} · {noteDate(note.created_at).date}
      </span>
    </span>
  </span>
);

/** Every note on the slide, newest first, for the slides table with notes expanded. */
const ExpandedNotes = ({ notes }: { notes: SlideStatus[] }) => (
  <span className="tw-flex tw-flex-col tw-divide-y tw-divide-solid tw-divide-x-0 tw-divide-spa-border-secondary">
    {notes.map(note => <NoteLine key={note.id} note={note} />)}
  </span>
);

export default ExpandedNotes;
